import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import "./index.css";
import "./grid.css";
import { router } from "./app/router";
import { AdminI18nProvider } from "./i18n/i18n-provider";
import { SessionProvider } from "./lib/session-provider";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AdminI18nProvider>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </AdminI18nProvider>
  </StrictMode>,
);
